export const {
  REACT_APP_API_DHL_URL: API_DHL_URL,
  REACT_APP_ENVIRONMENT: ENVIRONMENT,
  NODE_ENV,
} = process.env
